import { useTranslation } from "@i18n";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ReviewsListForEntity from "./ReviewsListForEntity";
import Text from "@CubeComponents/html/Text/Text";
function FileStatusInReviews({ fileVersionId, openAllReviewsCallback, spaceId }: any) {
  const { t } = useTranslation();
  const resource = { fileVersionId, resourceType: "RESOURCE_TYPE_FILE" };

  return (
    <div className="flex flex-col gap-4">
      <ReviewsListForEntity includeDefaultReviews spaceId={spaceId} resource={resource} />
      <div data-testid="viewAllReviewsBtn">
        <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={openAllReviewsCallback}>
          <Text>{t("View all Reviews")}</Text>
        </ButtonComponent>
      </div>
    </div>
  );
}

export default FileStatusInReviews;
